import { Lock, Link2, KeyRound, UserCheck } from "lucide-react";

export const ACCESS_MODES = {
  private: { label: "Privee", hint: "Visible uniquement par l'administrateur et les responsables autorises", icon: Lock, color: "#94A3B8" },
  link: { label: "Accessible par lien", hint: "Toute personne disposant du lien voit les photos publiees", icon: Link2, color: "#10B981" },
  code: { label: "Protegee par code", hint: "Le lien doit etre accompagne d'un code d'acces", icon: KeyRound, color: "#F59E0B" },
  participants: { label: "Reservee aux participants", hint: "Acces verifie par un code temporaire envoye a l'e-mail d'inscription", icon: UserCheck, color: "#0099CC" },
};

export function AccessBadge({ mode, testId }) {
  const m = ACCESS_MODES[mode] || ACCESS_MODES.private;
  const Icon = m.icon;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider border"
      style={{ color: m.color, borderColor: `${m.color}66`, background: "rgba(6,11,20,0.85)" }}>
      <Icon className="w-3 h-3" /> {m.label}
    </span>
  );
}
